import React, { useEffect, useState } from 'react'
import { Circles } from 'react-loader-spinner'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
import { Row } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import {
  isExtendButton,
  // isSessionNotActive
} from '../../utils/helper'
// import { useCountDown } from '../../Hooks/countDownHook'

function ExtendEndButton(props) {
  const { isFetching, handleEndParking, handleExtend, isEndParking, isExtendPrimary, screen, syncWithBtns, wideBtn, paymentData, isValidateTicketVisible, setBtnLoader, btnloader, isSessionActive, ticketData } = props
  // const [isSessionActive, setIsSessionActive] = useState(false)
  const [facilityData, setFacilityData] = useState(EMPTY_OBJECT)
  let key = 'faclityData'
  if (screen == 'extend') {
    key = 'ExtendData'
  } else {
    key = 'faclityData'
  }
  // const [days, hours, minutes, seconds] = useCountDown(screen)
  
  
  const { partner } = useParams()

  useEffect(() => {
    const facilityDataLoc = (screen == 'payment') ? JSON.parse(localStorage.getItem(key)) : JSON.parse(localStorage.getItem(key))?.facility
    setFacilityData(facilityDataLoc)
    // const sessionStatus = isSessionNotActive(days, hours, minutes, seconds)
    // setIsSessionActive(sessionStatus)
  },[isSessionActive])

  const extendParking = () => {
    setBtnLoader({
      ...btnloader,
      extend: true
    })
    handleExtend()
  }
  const endParking = () => {
    setBtnLoader({
      ...btnloader,
      endparking: true
    })
    handleEndParking()
  }
  const buttonComp = (classes = '') => {
    return (<>
          {(partner && isSessionActive && isExtendButton(facilityData, ['1']) && !paymentData?.event_id && (!paymentData?.permit_request_id && !ticketData?.permit_request_id) && (!paymentData?.user_pass_id && !ticketData?.user_pass_id) && (!paymentData?.reservation_id && !ticketData?.reservation_id)) && <div className={`${
            (syncWithBtns && (facilityData?.is_end_parking != 0 && isEndParking && isSessionActive)) ? 'mb-3 col-sm-12 col-12 col-sm' :
            (syncWithBtns && isValidateTicketVisible) ? 'mb-4 col' :
            (wideBtn) ? 'col-sm-12 col-12 col-sm' : 'col-sm-6 mb-3 mb-sm-0'
          } ${classes}`}>
        <button
          type='button'
          onClick={() => extendParking()}
          disabled={isFetching}
          style={{opacity: (isFetching) ? '0.7' : '1'}}
          className={`${isExtendPrimary ? 'text-decoration-none border-btn border bg-white text-primary border-primary rounded text-center w-100 ps-4 pe-4 pt-2 pb-2 mt-3 mt-sm-0'  : 'text-decoration-none border-btn border bg-white text-primary border-primary rounded text-center w-100 ps-4 pe-4 pt-2 pb-2'}`}>
          {/* <i className='fa fa-plus-circle me-1'></i>Extend */}

          <div className='d-flex justify-content-center align-items-center'>
            <span>{isExtendPrimary ? 'Extend' : 'Extend Duration'}</span>
            <span className='ms-2'>
              {(isExtendPrimary && isFetching && btnloader?.extend) ? <Circles
                height="20"
                width="20"
                style={{ display: 'inline-block' }}
                color="var(--bs-primary)"
                ariaLabel="circles-loading"
                visible={true}
              /> : null}
            </span>
          </div>
        </button>
      </div>}
      {((facilityData?.is_end_parking != 0 && isEndParking) && isSessionActive && !ticketData?.permit_request_id && !ticketData?.user_pass_id && !ticketData?.reservation_id) && <div className={`${(syncWithBtns && partner && isSessionActive && isExtendButton(facilityData, ['1'])) ? 'col-sm-12 col-12 col-sm' : (syncWithBtns && isValidateTicketVisible) ? 'mb-4 col' : wideBtn ? 'col-sm-12 col-12 col-sm' : 'col-sm-6'}`}>
        <button
          // onClick={() => handleEndParking()}
          disabled={isFetching}
          style={{opacity: (isFetching) ? '0.7' : '1'}}
          onClick={() => endParking()}
          type='button'
          className='text-decoration-none border-btn border bg-white text-primary border-primary rounded text-center w-100 ps-4 pe-4 pt-2 pb-2'>
          <div className='d-flex justify-content-center align-items-center'>
            <span>End Current Parking</span>
            <span className='ms-2'>
              {(isFetching && btnloader?.endparking) ? <Circles
                height="20"
                width="20"
                style={{ display: 'inline-block' }}
                color="#26A8EO"
                ariaLabel="circles-loading"
                visible={true}
              /> : null}
            </span>
          </div>
        </button>
      </div>}
      </>
    )
  }
  const returnButtons = (classes = '') => {
    if(isValidateTicketVisible && isExtendButton(facilityData, ['1']) && (facilityData?.is_end_parking != 0 && isEndParking && isSessionActive)) {
      return ( <div className='row'>
        {buttonComp(classes)}
      </div>)
    }
    return ( <>
        {buttonComp(classes)}
      </>
    )
  }

  if(syncWithBtns) {
    return (
      returnButtons()
    )
  } else if(wideBtn) {
    return (
      returnButtons('mb-3 mb-sm-3')
    )
  } else {
    return (
      <Row className='mb-4 m-auto w-100 justify-content-center'>
        {returnButtons()}
      </Row>
    )
  }
}

ExtendEndButton.propTypes = {
  dispatch: PropTypes.func,
  listData: PropTypes.array,
  isFetching: PropTypes.bool,
  handleEndParking: PropTypes.func,
  handleExtend: PropTypes.func,
  isEndParking: PropTypes.bool.isRequired,
  isExtendPrimary: PropTypes.bool.isRequired,
  screen: PropTypes.string,
  isTokenApiStarts: PropTypes.bool,
  syncWithBtns: PropTypes.bool,
  wideBtn: PropTypes.bool,
  isValidateTicketVisible: PropTypes.bool,
  paymentData: PropTypes.object,
  setBtnLoader: PropTypes.func,
  btnloader: PropTypes.object,
  isSessionActive: PropTypes.bool,
  ticketData: PropTypes.object,
}

ExtendEndButton.defaulProps = {
  dispatch: noop,
  listData: EMPTY_ARRAY,
  isFetching: false,
  handleEndParking: noop,
  handleExtend: noop,
  isEndParking: false,
  isExtendPrimary: false,
  screen: undefined,
  isTokenApiStarts: false,
  syncWithBtns: false,
  wideBtn: false,
  isValidateTicketVisible: false,
  paymentData: EMPTY_OBJECT,
  setBtnLoader: noop,
  btnloader: EMPTY_OBJECT,
  isSessionActive: true,
  ticketData: EMPTY_OBJECT,
}

function mapStateToProps({ PaymentReducer }) {
  return {
    isSessionActive: PaymentReducer.activeSession,
  }
}

export default connect(mapStateToProps)(ExtendEndButton)